import { SortType } from 'car-insurance/types';

export function getSortOrder(sort: SortType): 'asc' | 'desc' {
  if (sort === 'Recommended') {
    return 'asc';
  }

  return 'desc';
}
